<ng-container style="width:50vw">
    
  <h6 *ngIf="forEdition">Edition d'un élément</h6>
  <h6 *ngIf="!forEdition">Nouvel <span *ngIf="!determinedType">élément</span> <span *ngIf="determinedType">enfant</span></h6>
  <p class="help">
    <mat-icon>help_outline</mat-icon> 
    L'élément est ce que vous souhaitez ajouter à l'arbre, son type détermine le comportement au moment du diagnostic. <br>
    <!-- <span>Zone : </span>Une partie de la machine. Ex : Chaud <br> -->
    <!-- <span>Composant : </span>Une sous partie. Ex : Four <br> -->
    <!-- <span>Symptôme : </span>Le problème décrit par le client. Ex : Ne chauffe pas <br> -->
    <!-- <span>Question : </span>Ce qui est demandé au client par l'opérateur. Ex : Est-ce qu'il y a des pizzas dans le four ? <br> -->
    <span>Réponse : </span>La réponse donnée par le client. Ex : Non, il n'y a pas de pizzas en stock. <br>
    <span>Solution : </span>Ce qui permet de résoudre la panne. Ex : Il faut des pizzas en stock pour que le four puisse chauffer. <br> 
    <span>Elément : </span>Le reste <br> 
    L'élément de niveau inférieur est l'élément qui sera affiché après avoir cliqué sur l'élément en cours de création.
  </p>
    <form [formGroup]="formComposant">

      <!-- Type d'élément PARENT -->
      <div class="paragraphe"  *ngIf="!forEdition && !iAmRoot &&!determinedType">   
        <h6 class="paddMe">Type de l'élément :</h6>
        <mat-form-field style="width:50vw">
              <mat-select matInput formControlName="type" (selectionChange)="typeChanged($event)">
                <mat-option *ngFor="let arbreType of arbreTypes" [value]="arbreType.type_label">
                 {{ arbreType.type_label }}
                </mat-option>
              </mat-select>
        </mat-form-field>
      </div>
      
      <div class="paragraphe"  *ngIf="!forEdition && determinedType">     
        <h6 class="paddMe">Type de l'élément : {{determinedType}} </h6>       
      </div>

      <div class="paragraphe"  *ngIf="forEdition">     
        <h6 class="paddMe">Type de l'élément : {{data.composant.type}} </h6>       
      </div>


      <!-- Type d'élément ENFANT-->
      <div class="paragraphe"  *ngIf=" !iAmRoot && !isSolution ">   
        <h6 class="paddMe">Type de l'élément de niveau inférieur : </h6>
        <mat-form-field style="width:50vw">
          <mat-select matInput formControlName="childrenType" (selectionChange)="childrenTypeChanged($event)">
            <mat-option *ngFor="let arbreType of arbreTypes" [value]="arbreType.type_label">
            {{ arbreType.type_label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- <div class="paragraphe"  *ngIf="forEdition">     
        <h6 class="paddMe">Type de niveau inférieur : {{data.composant.children_type}} </h6>       
      </div> -->
      
      <!-- Codes Pannes -->

      <div class="paragraphe" *ngIf="!iAmRoot">
        <h6 class="paddMe">Codes Zones:</h6>
        <mat-form-field>
            <mat-select multiple [(value)]="selectedCodes" formControlName="codePanne" style="width:50vw">
                <input (keyup)="onKey($event)" placeholder="Chercher..."> 
                <mat-select-trigger>
                  {{selectedCodes ? selectedCodes[0] : ''}}
                  <span *ngIf="selectedCodes?.length > 1" class="example-additional-selection">
                    (+{{selectedCodes.length - 1}} {{selectedCodes?.length === 2 ? 'autre' : 'autres'}})
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let code of selectedPannes" [value]="code.code">{{code.code}} : {{code.nom}}
                </mat-option>
            </mat-select>
        </mat-form-field>
      </div>

      <!-- Label -->
          <div class="paragraphe">
            <h6 class="paddMe">Texte de l'élément :</h6>
              <mat-form-field style="width:50vw">
                <input matInput formControlName="label">
              </mat-form-field>
          </div>
        
       <!-- Parent -->   
          <div class="paragraphe" *ngIf="!iAmRoot">
            <h6 class="paddMe">Elément de niveau supérieur :</h6>    
            <button mat-icon-button aria-label="edit button" onclick="this.blur()" (click)="editLinks(1)" class="plusButton" *ngIf="!parent">
              <mat-icon class="plusIcon">add_circle</mat-icon>
            </button>
              <div class="box" *ngIf="parent">
                <div class="innerBox" (click)="editLinks(1)">
                  {{parent.label}}
                </div>
              </div>
          </div>

        <!-- Enfants -->  
            <div class="paragraphe" *ngIf="!isSolution"> 
              <h6 class="paddMe">Eléments de niveau inférieur :   
              <button mat-icon-button aria-label="edit button" (click)="editLinks(2)" class="plusButton" onclick="this.blur()" >
                <mat-icon class="plusIcon">edit</mat-icon>
              </button>
              <button *ngIf="forEdition" mat-icon-button aria-label="edit button" (click)="newElement()" class="plusButton" onclick="this.blur()" >
                <mat-icon class="plusIcon">add_circle</mat-icon>
              </button>
            </h6> 
                <ul class="boxCol"  cdkDropList (cdkDropListDropped)="drop($event)">
                  <li class="childrenBox" *ngFor="let child of children" cdkDrag>
                    {{child.label}}
                    <button mat-icon-button aria-label="delete" (click)="deleteChild(child)" class="leftIcon">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </li>
                </ul>
            </div>

            <div class="paragraphe" *ngIf="isSolution"> 
              <h6 class="paddMe">Les solutions n'ont pas d'enfants</h6> 
            </div>

          <br/>

          <!-- Last modifications on component -->
          <ng-container *ngIf="forEdition">
            <div *ngIf="data.composant.login">
              Dernière modification par <strong>{{data.composant.login}}</strong> le <strong>{{getNiceDate(data.composant.date_heure)}}</strong>
            </div>
            <div *ngIf="!data.composant.login && data.composant.date_heure">
              Dernière modification par <strong>Inconnu</strong> le <strong>{{getNiceDate(data.composant.date_heure)}}</strong>
            </div>
            <div *ngIf="!data.composant.login && !data.composant.date_heure">
              Nous n'avons pas les informations de la dernière modification
            </div>
          </ng-container>
          <!-- Actions -->

          <ng-container *ngIf="forEdition">
            <button class="btn btn-primary" (click)="deleteElement()" *ngIf="!iAmRoot && forAdmin">Supprimer</button>
            <button class="btn btn-secondary" (click)="close()">Annuler</button>
            <button class="btn btn-tertiary"  (click)="onSubmit()" >Modifier</button>
            <!-- Validation de l'élément -->
              <mat-checkbox *ngIf="!data.composant.validated && forAdmin" class="mgin" (change)="validateComponent($event)">Valider</mat-checkbox>
          </ng-container>
          
          <ng-container *ngIf="!forEdition">
            <button class="btn btn-secondary" (click)="close()">Annuler</button>
            <button class="btn btn-tertiary"  (click)="onSubmit()" >Créer</button>
            <mat-checkbox *ngIf="forAdmin" class="mgin" (change)="validateComponent($event)">Valider</mat-checkbox>
          </ng-container>
          
          <br>   

    </form>
      
  </ng-container>